export default "<h1>Type11File list</h1>\n<spec-app-type11-file-table [clickHandler]=\"createClickHandler()\"></spec-app-type11-file-table>";